export const phoneRegex = /^[0-9]{10}$/;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const mobileRegExp = /^(\(\d{3}\)\s\d{3}\s\d{4}|\d{10})$/;
